import './App.css';
import SideBar from './components/SideBar';
import { Routes, Route } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ProtectedRoute from "./api/ProtectedRoute";
import { ROLES } from "./constants/roles";

// الصفحات
import OrdersPage from "./pages/OrdersPage";
import AddOrderPage from "./pages/AddOrderPage";
import LoginPage from "./pages/LoginPage";
import OrderDetailsPage from './pages/OrderDetailsPage';
import StatisticsPage from './pages/StatisticsPage';
import ResetPasswordPage from "./pages/ResetPassword";
import PublicOrderPage from "./pages/PublicOrderPage";

function App() {

  const location = useLocation();

  const hideSidebar = ["/login", "/reset-password", "/request-order"].includes(location.pathname);

  return (
    <div className="app-layout">
      {!hideSidebar && <SideBar />}

      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={true} 
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />

      <div className={`content ${!hideSidebar ? "with-sidebar" : ""}`}>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/request-order" element={<PublicOrderPage />} />
          <Route path="/" element={<ProtectedRoute allowedRoles={[ROLES.ADMIN, ROLES.SHOWROOM]}><StatisticsPage /></ProtectedRoute>} />
          <Route path="/orders" element={<ProtectedRoute><OrdersPage /></ProtectedRoute>} />
          <Route path="/add-order" element={<ProtectedRoute allowedRoles={[ROLES.ADMIN, ROLES.SHOWROOM]}><AddOrderPage /></ProtectedRoute>} />
          <Route path="/order-details/:id" element={<ProtectedRoute><OrderDetailsPage /></ProtectedRoute>} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
        </Routes>
      </div>
    </div>
  );
}

export default App;
